import React from "react";
import ReactDOM from "react-dom/client";
import './axios/axios';
import Skeleton from "./components/skeleton";
import { BrowserRouter } from "react-router-dom";
import "./css/style.css";
import "./css/custom.css";

import "./css/responsive.css";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <Skeleton />
    </BrowserRouter>
  // </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
